import { SUPPORTED_LANG, SupportedLocale } from './lang'
import { rememberSession } from '@/utils/sessionCache'

export type Locale = SupportedLocale
export type Bundle = Record<string, any> // expected shape: { messages: {...}, contents: {...}, ... }

const cache = new Map<Locale, Bundle>()
const TRANSLATION_CACHE_TTL_MS = 30 * 60 * 1000

export function isSupportedLocale(v: string | undefined | null): v is Locale {
  return !!v && (SUPPORTED_LANG as readonly string[]).includes(v)
}

export async function fetchBundle(locale: Locale): Promise<Bundle> {
  if (cache.has(locale)) return cache.get(locale)!

  const json = await rememberSession(`i18n:${locale}:v19`, TRANSLATION_CACHE_TTL_MS, async () => {
    const res = await fetch(`/api/translations/${locale}`)

    if (!res.ok) throw new Error(`Failed to fetch bundle for ${locale}`)

    return (await res.json()) as Bundle
  })

  if (!json || typeof json !== 'object' || !('messages' in json)) {
    throw new Error(`Invalid translation bundle for ${locale}`)
  }
  cache.set(locale, json)
  return json
}

export function getCachedBundle(locale: Locale): Bundle | undefined {
  return cache.get(locale)
}
